export const cx = (...args: unknown[]): string => {
  return args
    .flat(Infinity)
    .map((arg: unknown): string => {
      if (!arg) return '';
      if (typeof arg === 'string') return arg;
      if (typeof arg === 'object') {
        return Object.entries(arg)
          // @ts-ignore
          .filter(([_, value]): boolean => Boolean(value))
          .map(([key]): string => key)
          .join(' ');
      }
      return '';
    })
    .filter(Boolean)
    .join(' ');
};
